import React, { useState } from 'react';
import { Popover, ListItemIcon, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { CustomButton } from '../customButton/CustomButton';
import './popoverModal.scss';

export const PopoverModal = ({ children, closeOnClick, infoIcon, asButton = false, label = "" }) => {
    const [isOpen, setIsOpen] = useState(null);

    const handleClick = (event) => {
        setIsOpen(event.currentTarget);
    };

    const handleClose = () => {
        setIsOpen(null);
    };

    const open = Boolean(isOpen);

    return (
        <div className='popover-container'>
            {asButton ? (
                <CustomButton
                    label={label}
                    onClick={(e) => setIsOpen(e.target)}
                    variant="outlined"
                    endIcon={<KeyboardArrowDownIcon />}
                />
            ) : infoIcon ? (
                <ListItemIcon style={{ minWidth: 'auto', marginRight: 8 }}>
                    <InfoIcon className="display-icon" onClick={handleClick} style={{ fontSize: 20 }} />
                </ListItemIcon>
            ) : (
                <IconButton onClick={handleClick} size="small">
                    <MoreVertIcon className="display-icon" />
                </IconButton>
            )}

            <Popover
                open={open}
                anchorEl={isOpen}
                onClose={handleClose}
                className='popover-content'
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <div className='popover-children' onClick={closeOnClick ? handleClose : null} aria-hidden='true'>
                    {children}
                </div>
            </Popover>
        </div>
    )
}